<ng-container *transloco="let t; prefix: scope">
  <ng-container *ngIf="canShowSubscriptionInfo(); else noCollaborationMessageTemplate">
    <div class="mb-4" *ngIf="hasError()">
      <bl-frontend-alert severity="danger" [content]="errorMessage$ | async"> </bl-frontend-alert>
    </div>
    <div class="mb-4" *ngIf="isArchived()">
      <bl-frontend-alert severity="warning" [content]="t('databaseIsArchivedMessage')"> </bl-frontend-alert>
    </div>
    <div class="flex gap-6 w-full">
      <div class="w-2/3 flex flex-col gap-6">
        <div class="flex flex-row gap-6">
          <div class="rounded-lg border border-blg-grey-200 w-1/2 relative">
            <app-lundify-bundle></app-lundify-bundle>
          </div>
          <div class="rounded-lg border border-blg-grey-200 w-1/2 p-6">
            <app-subscription-users [client]="client"></app-subscription-users>
          </div>
        </div>
        <div class="rounded-lg p-6 border border-blg-grey-200 w-full">
          <app-paying-part [client]="client" [active]="active"></app-paying-part>
        </div>

        @if (hasEmailPortal()) {
          <div class="mt-10">
            <bl-frontend-tooltip [heading]="t('copyEmailTooltip')" [content]="emailPortalAddress()">
              <bl-frontend-button
                variant="secondary"
                [text]="t('copyEmailButton')"
                (onclick)="copyEmailToClipboard()"
                [trailingIcon]="{ name: 'copy' }">
              </bl-frontend-button>
            </bl-frontend-tooltip>
          </div>
        }
      </div>
      <div class="w-1/3">
        <div class="rounded-lg border border-blg-grey-200 p-6">
          <app-subscription-expense></app-subscription-expense>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noCollaborationMessageTemplate>
    <div class="rounded-lg border border-blg-grey-200 w-full relative p-6">
      <h4>{{ t('noCollaborationMessageTitle') }}</h4>
      <p>
        {{ t('noCollaborationMessageContent') }}
      </p>
    </div>
  </ng-template>
</ng-container>
